import { Injectable } from "@angular/core";
import { BaseListService } from "../../@core/services/base-list.service";
import { SystemService } from "../../@core/services/system.service";
import { GET_POSTAL_CODES } from "../../data/definitions/postal-codes.definition";
import { BaseDataService } from "../../data/services/base-data.service";
import { DataService } from "../../data/services/data.service";
import { GetPostalCodesQuery, GetPostalCodesQueryVariables, PostalCode, SearchInput } from "../../generated/generated-types";

@Injectable()
export class PostalCodeService extends BaseListService<PostalCode> {

    constructor(private dataService: DataService,
        private baseDataService: BaseDataService,
        private systemService: SystemService) {
        super();
    }

    getItems(searchInput?: SearchInput) {

        let fragment = GET_POSTAL_CODES;

        return this.baseDataService.query<GetPostalCodesQuery, GetPostalCodesQueryVariables>(
            fragment, {
            input: searchInput
        });
    }

}
